import useAuthStore from '@/stores/authStore'
import { useEffect, useState } from 'react'
import { LockupWhite } from '@/assets'
import Text from '@/elements/Text'
import Flex from '@/elements/Flex'
import FormInput from '@/elements/FormInput'
import Button from '@/elements/Button'
import { getInviteFlowParams } from '@/utils/inviteFlow'
import { LogOut } from 'lucide-react'
import { IS_MOBILE_APP } from '@/constants'

// THIS IS USED TO DISABLE THE INVITE FLOW FOR TESTING PURPOSES
const DISABLE_INVITE_FLOW = true

function InvitationCode() {
  const { initialize, logout } = useAuthStore()

  const [noCode, setNoCode] = useState(false)

  const [code, setCode] = useState('')
  const [email, setEmail] = useState('')

  const onInviteCodeSubmit = () => {
    initialize(false, code, email)
  }

  const onNoCodeSubmit = () => {
    initialize(false, 'NO_CODE', email)
  }

  useEffect(() => {
    const params = getInviteFlowParams()
    if (params) {
      setCode(params.inviteCode ?? '')
      setEmail(params.email ?? '')
    }
    // Only runs once
  }, [])

  useEffect(() => {
    // Only runs once
    if (!IS_MOBILE_APP) return
    if (!DISABLE_INVITE_FLOW) return
    initialize(false, 'NO_CODE', `user${Date.now()}@example.com`)
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const isCodeValid = code.length === 9 && code[4] === '-' && /^[0-9-]+$/.test(code)
  const isEmailValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
  const isFormValid = (isCodeValid || noCode) && isEmailValid

  return (
    <Flex
      component='main'
      align='center'
      justify='center'
      gap={8}
      p={4}
      className='auth'
      style={{ height: '100svh' }}
    >
      <LockupWhite
        style={{
          width: 380,
          maxWidth: '80%'
        }}
      />
      <Flex align='center' gap={5}>
        <Text variant='h4' color='white'>
          {noCode
            ? 'Please enter your email.'
            : 'Please enter your invite code and email to continue.'}
        </Text>
        <Flex align='center' gap={4} style={{ minWidth: 300 }}>
          {noCode ? null : (
            <FormInput
              style={{ width: '100%' }}
              name='first'
              placeholder='XXXX-XXXX'
              value={code}
              onChange={e => setCode(e.target.value)}
            />
          )}
          <FormInput
            style={{ width: '100%' }}
            name='second'
            placeholder='Your email'
            value={email}
            onChange={e => setEmail(e.target.value)}
          />

          <Flex gap={2} wfull>
            <Button
              fullWidth
              variant='accent'
              onClick={noCode ? onNoCodeSubmit : onInviteCodeSubmit}
              disabled={!isFormValid}
              styles={{ width: '100%' }}
            >
              Submit
            </Button>
            <Button
              fullWidth
              variant='primary'
              onClick={() => setNoCode(!noCode)}
              styles={{ width: '100%' }}
            >
              {noCode ? 'Go back' : 'I don\'t have an invite code'}
            </Button>
          </Flex>
        </Flex>
      </Flex>
      <Button variant='primary' onClick={logout}>
        <LogOut />
        Log Out
      </Button>
    </Flex>
  )
}

export default InvitationCode
